<template>
	<v-card outlined rounded="lg" class="region-visits-rate-card">
		<v-card-text class="pa-3">
			<!-- title + percentage -->
			<div class="d-flex align-center justify-space-between">
				<span class="text-subtitle-2 font-weight-bold">{{ title }}</span>

				<v-chip
					small
					color="grey lighten-4"
					text-color="primary"
					class="font-weight-bold region-visits-rate-card__pill"
				>
					{{ $options.filters.formatNumber(percentage) }}%
				</v-chip>
			</div>

			<v-progress-linear
				color="primary"
				background-color="grey lighten-3"
				rounded
				height="8"
				class="mt-3"
				:value="percentage"
			></v-progress-linear>

			<!-- visited + remaining + details link -->
			<div class="d-flex align-center justify-space-between mt-2">
				<span class="text-caption green--text text--darken-2">
					{{ $T('visited-customers-count', { count: $options.filters.formatNumber(visitedCount) }) }}
				</span>

				<span class="text-caption grey--text text--darken-1">
					{{ $T('remaining-customers-count', { count: $options.filters.formatNumber(remainingCount) }) }}
				</span>

				<a
					v-if="showDetailsLink"
					class="text-caption primary--text region-visits-rate-card__link"
					@click="$emit('details')"
				>
					{{ $T('view-details') }}
				</a>
				<span v-else></span>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import moment from 'moment';

export default {
	name: 'RegionVisitsRateCard',

	props: {
		percentage: { type: Number, default: 0 },
		visitedCount: { type: Number, default: 0 },
		remainingCount: { type: Number, default: 0 },
		showDetailsLink: { type: Boolean, default: false },
		date: { type: String, default: null },
	},

	computed: {
		title() {
			if (!this.date || moment(this.date).isSame(moment(), 'day')) {
				return this.$T('region-visits-percentage-today');
			}

			return this.$T('region-visits-percentage-at-$', { date: moment(this.date).format('DD MMMM YYYY') });
		}
	}
}
</script>

<style lang="scss">
.region-visits-rate-card {
	&__link {
		text-decoration: underline;
	}
}
</style>
